import { QueryGroup, MiciCaseList, MiciFilter } from '../../services/types/MiciCases';
import { ApiState, Action } from '../../types';
import { serviceReducer, callService } from '../../shared/hooks/serviceReducer';

export type MiciAction =
  | Action<MiciCaseList, MiciFilter>
  | {
      type: 'QUERY_GROUP';
      value: QueryGroup;
    }
  | { type: 'PAGE'; value: number }
  | { type: 'PAGE_SIZE'; value: number }
  | { type: 'ORDER'; column: string; descending: boolean };

const reducer = (
  state: ApiState<MiciCaseList, MiciFilter>,
  action: MiciAction
): ApiState<MiciCaseList, MiciFilter> => {
  switch (action.type) {
    case 'QUERY_GROUP': {
      const filter = { ...state.filter, queryGroup: action.value, pageNumber: 1 };
      return callService(state, filter);
    }
    case 'PAGE':
      return callService(state, { pageNumber: action.value });
    case 'PAGE_SIZE':
      return callService(state, { pageSize: action.value });
    case 'ORDER':
      return callService(state, { sortField: action.column, sortDescending: action.descending });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
